import React, { useEffect, useState } from "react";


const StatusUpdate = (params) => {
  console.log({ params });
  const [locationId, setLocationId] = useState("");
  const [statusId, setStatusId] = useState("");

  useEffect(() => {
    setLocationId(params.locationId);
    setStatusId(params.statusId);
    return () => {};
  }, [params.locationId, params.statusId, params?.isStatusChanged]);

  const locationNameChangeHandler = (e) => {
    const { value } = e.target;
    setLocationId(value);
    const result =
      params?.tableData &&
      params?.tableData?.find(
        (item) => parseInt(item?.locationId) === parseInt(value)
      );
    if (result) {
      setStatusId(result?.statusValue);
    } else {
      setStatusId("");
    }
  };

  return (
    <>
      <div>
        <h4 className="view-heading">Candidate Status Update</h4>
        <div className="grid-status_update">
          <section className="grid-status-dropdown">
            <div>
              <label className="form-label" htmlFor={"Location Name"}>
                Location Name:
              </label>
              <select
                className="form-select"
                value={locationId}
                name="locationId"
                onChange={(e) => locationNameChangeHandler(e)}
              >
                <option value="">Select</option>
                {params.masterData?.locationList?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              {/* {searchErrors['locationId'] &&
              searchErrors['locationId'].map((error) => (
                <div className="invalid-input">{error}</div>
              ))} */}
            </div>
            <div>
              <label className="form-label" htmlFor={"Status"}>
                Status:
              </label>
              <select
                className="form-select"
                value={statusId}
                name="status"
                onChange={(e) => {
                  setStatusId(e.target.value);
                }}
              >
                {params.masterData?.statusList?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              {/* {searchErrors['locationId'] &&
              searchErrors['locationId'].map((error) => (
                <div className="invalid-input">{error}</div>
              ))} */}
            </div>
          </section>
          <section className="grid-status-date-items">
            <div>
              <label className="form-label" htmlFor={"PositionsList"}>
                Level:
              </label>
              <span className="d-block">
                {" "}
                {params?.positionsList?.length > 0
                  ? params?.positionsList?.map((item) => item.name).join(" , ")
                  : null}
              </span>
            </div>
            <div>
              <label className="form-label" htmlFor={"registrationData"}>
                Creation Date:
              </label>
              <span className="d-block">{params?.creationDate ?? ""}</span>
            </div>
            <div>
              <label className="form-label" htmlFor={"registrationData"}>
                Submit Date:
              </label>
              <span className="d-block">{params?.submitDate ?? ""}</span>
            </div>
          </section>
          <section className="status-btn-bottom">
            <label> </label>
            <div className="status-btn-group">
              <button
                className="btn btn-primary "
                type="button"
                onClick={() => params.getCandidateUpdate(locationId, statusId)}
              >
                Update Status
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  setLocationId(params.locationId);
                  setStatusId(params.statusId);
                }}
              >
                Reset
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default StatusUpdate;
